module.exports = __webpack_public_path__ + "img/cs-icons-twitter-filled.45578702.svg";